<template>
  <div class="designeroption" v-if="options_loaded && passed_filter && panel_required">
    <h3>{{ title }}</h3>
    <div :id="'radio--' + component_id">
      <div>
        <div class="radiooption stylesoption" v-if="!loading" :data-designer-component-id="component_id">
          <span v-for="option in filtered_option_list"><label><input type="radio" v-model="localTarget"
                                                                     :name="'radio_' + component_id"
                                                                     :value="option.value"/> {{ option.label }}</label></span>
        </div>
        <div v-if="loading">
          <p>Loading Options</p>
        </div>
      </div>
    </div>
  </div>
</template>


<script type="text/ecmascript-6">
import DesignerQuestionCollection from "./DesignerQuestionCollection.vue";

export default {
  mixins: [
      DesignerQuestionCollection
  ],
  props: {
    title: {
      default(){
        return 'Bar Handle Position';
      }
    },
    component_id: {
      default(){
        return 'bar_handle_position'
      }
    },
    question: {
      default(){
        return 'bar_handle_position'
      }
    },
    hardwareHandle: {
      required: true,
    }
  },
  computed: {
    url(){
      return '/api/options/' + this.fabricator + '/collection?question=bar_handle_position'  + '&hardware_handle=' + this.hardwareHandle;
    },
    cache_key(){
      return '_' + this.question + '_' + this.hardwareHandle;
    },
    panel_required(){
      return Array.isArray(this.filtered_option_list) && this.filtered_option_list.length > 1;
    }
  },
  watch: {
    'cache_key': function (val, oldVal) {
      this.update_options();
    },
    'panel_required': function (val, oldVal) {
      if(!this.panel_required) {
        this.localTarget = null;
      }
    },
  }
}
</script>
